<template>
  <div class="log">
    <button
      @click.stop="dialog = true"
      :title="'View ' + title + ' Details'"
      class="view-ass-btn"
    >
      View
    </button>

    <v-dialog
      v-model="dialog"
      max-width="36rem"
      content-class="view-detail-dialog"
    >
      <v-form ref="form">
        <v-card class="comments-view detail-popup-card">
          <header class="detail-popup-header">
            <div class="detail-popup-header__brand">
              <div class="detail-popup-header__badge" aria-hidden="true">
                <v-icon>{{ headerIcon }}</v-icon>
              </div>
              <div class="detail-popup-header__copy">
                <h2 class="detail-popup-title">{{ title }} Details</h2>
              </div>
            </div>
            <v-btn
              icon
              class="detail-popup-close"
              @click.prevent="dialog = false"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <v-card-text class="detail-popup-body">
            <div class="detail-popup-panel">
              <div class="detail-popup-row">
                <span class="detail-popup-label">{{ headers.id }}</span>
                <strong class="detail-popup-value detail-popup-value--mono">
                  {{ idDisplay }}
                </strong>
              </div>

              <div class="detail-popup-row">
                <span class="detail-popup-label">{{ headers.name }}</span>
                <strong class="detail-popup-value">
                  {{ nameDisplay }}
                </strong>
              </div>

              <div v-if="headers.email" class="detail-popup-row">
                <span class="detail-popup-label">{{ headers.email }}</span>
                <strong class="detail-popup-value">
                  {{ detail.email || "N.A" }}
                </strong>
              </div>

              <div v-if="headers.phone" class="detail-popup-row">
                <span class="detail-popup-label">{{ headers.phone }}</span>
                <strong class="detail-popup-value">
                  {{ phoneDisplay }}
                </strong>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      x: {
        error: null,
      },
      items: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  props: {
    detail: Object,
    headers: Object,
    title: String,
  },
  computed: {
    headerIcon() {
      return this.title === "Transporter" ? "local_shipping" : "person";
    },
    idDisplay() {
      if (!this.detail) return "—";
      return this.detail.driverId || this.detail.transporterId || "—";
    },
    nameDisplay() {
      if (!this.detail) return "—";
      if (this.title === "Transporter") {
        return this.detail.transporterName || "—";
      }
      return this.detail.name || "—";
    },
    phoneDisplay() {
      if (!this.detail) return "—";
      if (this.detail.countryCode && this.detail.phoneNo) {
        return `${this.detail.countryCode}-${this.detail.phoneNo}`;
      }
      return this.detail.phoneNo || "—";
    },
  },
  created() {},
  methods: {},
};
</script>
<style scoped>
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}

.user {
  padding: 10px;
}

.view-ass-btn {
  background: linear-gradient(160deg, #f58220 0%, #ea7a1c 100%);
  border: 0;
  border-radius: 0.5rem;
  box-shadow: 0 0.25rem 0.75rem rgba(234, 122, 28, 0.28);
  color: #ffffff;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  padding: 0.35rem 0.7rem;
  text-decoration: none;
}

.detail-popup-card {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
  max-height: none !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.detail-popup-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.75rem 1rem;
}

.detail-popup-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.detail-popup-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  position: relative;
  width: 2.35rem;
}

.detail-popup-header__badge::after {
  background: #f58220;
  border-radius: 999px;
  bottom: 0.26rem;
  content: "";
  height: 0.18rem;
  left: 0.48rem;
  position: absolute;
  right: 0.48rem;
}

.detail-popup-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
  margin-top: -0.1rem;
}

.detail-popup-header__copy {
  min-width: 0;
}

.detail-popup-title {
  color: #1c2b5f !important;
  font-size: 1rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}


.detail-popup-close {
  color: #5b6475 !important;
}

.detail-popup-body.v-card__text {
  flex: 0 0 auto !important;
  max-height: none !important;
  overflow: visible !important;
  padding: 0.85rem 1rem 1rem !important;
}

.detail-popup-panel {
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.85rem;
  overflow: hidden;
}

.detail-popup-row {
  align-items: center;
  border-bottom: 0.0625rem solid #f3e6d4;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(7.5rem, 9rem) minmax(0, 1fr);
  min-height: 2.55rem;
  padding: 0.55rem 0.9rem;
}

.detail-popup-row:last-child {
  border-bottom: 0;
}

.detail-popup-label {
  color: #8a857c;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  line-height: 1.3;
  text-transform: uppercase;
}

.detail-popup-value {
  color: #1a1916;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  overflow-wrap: anywhere;
}

.detail-popup-value--mono {
  color: #1c2b5f;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 800;
}

html.oms-night-mode .application .detail-popup-card {
  background: var(--oms-surface) !important;
  border-color: var(--oms-border) !important;
  color: var(--oms-ink) !important;
}

html.oms-night-mode .application .detail-popup-header {
  background: linear-gradient(
    135deg,
    rgba(234, 122, 28, 0.16) 0%,
    var(--oms-surface) 55%,
    var(--oms-surface-soft) 100%
  );
  border-color: var(--oms-border);
}

html.oms-night-mode .application .detail-popup-title {
  color: #f8bd82 !important;
}


html.oms-night-mode .application .detail-popup-panel {
  background: var(--oms-surface-soft) !important;
  border-color: var(--oms-border) !important;
}

html.oms-night-mode .application .detail-popup-row {
  border-color: var(--oms-border) !important;
}

html.oms-night-mode .application .detail-popup-label {
  color: var(--oms-muted) !important;
}

html.oms-night-mode .application .detail-popup-value {
  color: var(--oms-ink-strong) !important;
}

@media (max-width: 40rem) {
  .detail-popup-header {
    padding: 0.65rem 0.85rem;
  }

  .detail-popup-body.v-card__text {
    padding: 0.7rem 0.8rem 0.9rem !important;
  }

  .detail-popup-row {
    gap: 0.2rem;
    grid-template-columns: 1fr;
    min-height: 0;
    padding: 0.55rem 0.75rem;
  }
}
</style>

<style>
.application .v-dialog.view-detail-dialog {
  border-radius: 1rem !important;
  overflow: hidden !important;
}

.application .v-dialog.view-detail-dialog .detail-popup-card {
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
}
</style>
